import { atom } from 'jotai';

export const puzzleStepAtom = atom(0); //dictates which step the player is at in each puzzle

export const activePuzzleAtom = atom(1); //dictates which puzzle is active 1,2 or 3

export const puzzleIsInteractbleAtom = atom(false);

export const enableMapAtom = atom(false);
